"use client";

import { useTranslations } from "next-intl";
import type { FormValidationMessages } from "@/lib/validation/formValidationMessages";

/** Строки валидации: namespace `strings.formValidation` в каталоге messages. */
export function useFormValidationMessages(): FormValidationMessages {
  const t = useTranslations("strings.formValidation");
  return {
    firstNameRequired: t("firstNameRequired"),
    lastNameRequired: t("lastNameRequired"),
    emailRequired: t("emailRequired"),
    emailInvalid: t("emailInvalid"),
    phoneRequired: t("phoneRequired"),
    phoneInvalid: t("phoneInvalid"),
    categoryRequired: t("categoryRequired"),
    pairCountryRequired: t("pairCountryRequired"),
    fieldRequired: t("fieldRequired"),
    partnerRoleRequired: t("partnerRoleRequired"),
    partnerLevelRequired: t("partnerLevelRequired"),
    partnerCountryRequired: t("partnerCountryRequired"),
    partnerCityRequired: t("partnerCityRequired"),
    partnerFirstNameRequired: t("partnerFirstNameRequired"),
    partnerLastNameRequired: t("partnerLastNameRequired"),
    partnerEmailRequired: t("partnerEmailRequired"),
    partnerEmailInvalid: t("partnerEmailInvalid"),
  };
}
